// Unpublished Work © 2021-2023 Deere & Company

import jwtDecode from 'jwt-decode';
import {processEnvSvc} from '../../services/process-env-svc';

export const MILLI_SECONDS_IN_A_SECOND = 1000;

export const isTokenExpired = (token) => {
    if (processEnvSvc('BYPASS_OKTA')) {
        return false;
    }

    const decodedToken = jwtDecode(token);

    const tokenExpirationInMilliSeconds = decodedToken.exp * MILLI_SECONDS_IN_A_SECOND;

    console.log('token expiring on :', new Date(tokenExpirationInMilliSeconds)); // eslint-disable-line no-console

    return new Date().getTime() > tokenExpirationInMilliSeconds;
};
